<template>
    <div class="row">
        
        <div class="col-12 col-xl-12 stretch-card">
            <div class="row flex-grow-1">
                <div class="col-md-4 grid-margin stretch-card">
                    <div class="card card-total">
                        <div class="card-body text-center card-body-primary">
                            <h6 class="card-h6"> {{ i18n.t('tables.regulations.expense_total') }}
                            </h6>
                            <h3 class="card-h3">{{ amount?.total_amount?.toFixed(2) ?? 0 }} {{
                                i18n.t('symbole.currency.mad') }}</h3>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 grid-margin stretch-card">
                    <div class="card card-total">
                        <div class="card-body text-center card-body-secondary">
                            <h6 class="card-h6"> {{ i18n.t('tables.regulations.total_paid') }}
                            </h6>
                            <h3 class="card-h3">{{ amount?.total_amount_paid?.toFixed(2) ?? 0 }} {{
                                i18n.t('symbole.currency.mad') }}</h3>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 grid-margin stretch-card">
                    <div class="card card-total">
                        <div class="card-body text-center card-body-tertiary">
                            <h6 class="card-h6"> {{ i18n.t('tables.regulations.remaining_amount') }}
                            </h6>
                            <h3 class="card-h3">{{ amount?.remaining_amount?.toFixed(2) ?? 0 }} {{
                                i18n.t('symbole.currency.mad') }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script setup>
import { defineProps, toRefs } from 'vue';
const APP_URL = process.env.VUE_APP_URL;
import i18n from "@/i18n/index"
const props = defineProps({
    amount: Object,
    isBtn: Boolean
});

let { amount, isBtn } = toRefs(props);
</script>